export default __webpack_public_path__ + "2b4f0b6462122e2f8a1622196372eb01.png";